<template>
  <fin-elevated-box v-bind="$attrs"
                    class="advancedElevatedBox"
  >
    <h4 class="advancedElevatedBox__title" v-if="$slots.title">
      <slot name="title"></slot>
    </h4>
    <v-img :src="image" v-if="image"
           class="mb-8 mx-auto"
           contain
           width="234px"/>
    <h4 class="advancedElevatedBox__subtitle" v-if="$slots.subtitle">
      <slot name="subtitle"></slot>
    </h4>
    <p class="advancedElevatedBox__text" v-if="$slots.content">
      <slot name="content"></slot>
    </p>

    <v-container v-if="buttons">
      <v-row>
        <v-col v-for="(btn, index) in buttons" :key="index"
               :class="'justify-center pr-1 ' + $vuetify.breakpoint.xs ? 'pt-0' : ''" align="center">
          <v-btn :color="$finColors.primaryDark"
                 :class="btn.class"
                 @click="onClick(btn.eventName, $event)">
            <span style="color:white">{{ btn.name }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

  </fin-elevated-box>
</template>

<script>
import FinElevatedBox from '../elevatedBox/index'

export default {
  name: 'finAdvancedElevatedBox',
  components: {FinElevatedBox},
  props: {
    image: {
      type: String
    },
    buttons: {
      type: Array
    },
  },
  methods: {
    onClick: function (name, event) {
      this.$emit(name, event)
    }
  }
}
</script>

<style lang="scss" scoped>

.advancedElevatedBox {

  .advancedElevatedBox__title {
    font-family: $heading-font-family;
    font-size: 2.3em;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.1;
    letter-spacing: normal;
    text-align: center;
  }

  .advancedElevatedBox__subtitle {
    font-size: 1.4em;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.1;
    letter-spacing: normal;
    text-align: center;
  }

  .advancedElevatedBox__text {
    font-size: 1.1em;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
  }
}

</style>
